export default __webpack_public_path__ + "static/media/cookies.68a259c1.svg";